module.exports = __webpack_public_path__ + "img/close.7ae24c7f.svg";